import React from 'react';
import './DyedReflectivePage.css';

const models = [
  { name: 'DPAF 05', VLT: '4%', IRR: '62%', UVR: '100%', OD: '1.28', TSER: '65%' },
  { name: 'DPAF 10', VLT: '9%', IRR: '61%', UVR: '100%', OD: '0.98', TSER: '63%' },
  { name: 'DPAF 15', VLT: '17%', IRR: '62%', UVR: '100%', OD: '0.73', TSER: '55%' },
  { name: 'DPAF 20', VLT: '20%', IRR: '75%', UVR: '100%', OD: '0.69', TSER: '65%' },
  { name: 'DPAF 30', VLT: '30%', IRR: '62%', UVR: '100%', OD: '0.56', TSER: '50%' },
  { name: 'DPAF 45', VLT: '50%', IRR: '29%', UVR: '100%', OD: '0.48', TSER: '35%' },
];

const DyedReflectivePage = () => (
  <main className="dyed-reflective-main">
    <section className="dyed-reflective-top">
      <div className="dyed-reflective-top-content">
        <h1>Dyed Reflective Window Film</h1>
      </div>
    </section>

    <section className="dyed-reflective-hero">
      <div className="dyed-reflective-hero-content">
        <p className="dyed-reflective-subtitle">Enhance Comfort, Privacy, and Energy Efficiency</p>
        <p className="dyed-reflective-intro">
          Reflective architectural films are a smart, modern solution for enhancing indoor comfort, energy efficiency, and privacy in both residential and commercial spaces. These films use a high clarity layered structure to reflect a significant amount of solar radiation, offering superior performance while maintaining a sleek exterior appearance.
        </p>
      </div>
    </section>

    <section className="dyed-reflective-benefits">
      <h2>Core Benefits</h2>
      <ul className="dyed-reflective-benefits-list">
        <li><b>Superior Solar Heat Rejection</b> — Reflective films are engineered to reflect a high percentage of solar heat — helping regulate indoor temperatures and reduce the need for constant air conditioning. This can lead to lower energy bills and a more comfortable environment year-round.</li>
        <li><b>UV Blockage for Interior Protection</b> — With up to 100% ultraviolet ray rejection, these films help shield furnishings, flooring, and occupants from harmful sun exposure, reducing fading and potential health risks.</li>
        <li><b>Glare Control for Visual Comfort</b> — The reflective surface helps reduce eye strain by significantly cutting down on excessive sunlight and screen glare, especially in offices or rooms with large windows.</li>
        <li><b>One-Way Daytime Privacy</b> — Featuring a mirror-like exterior, these films provide excellent daytime privacy by limiting visibility from the outside in, while still allowing natural light to filter through from the inside.</li>
        <li><b>Modern Aesthetic Appeal</b> — Available in a range of tones and reflectivity levels, reflective films add a polished, modern look to building façades, enhancing both function and design.</li>
      </ul>
    </section>
    <div className="dyed-reflective-img-center">
      <img src="https://i.postimg.cc/rskncgsX/dyed-reflective-dermaa-2.png" alt="Dyed Reflective Derma Example 2" className="dyed-reflective-content-img" />
    </div>

    <section className="dyed-reflective-where">
      <h2>Where It Works Best</h2>
      <ul className="dyed-reflective-where-list">
        <li><b>Homes and Villas:</b> Maintain privacy and indoor comfort without drawing the curtains.</li>
        <li><b>Corporate Offices:</b> Increase energy efficiency and create a professional atmosphere.</li>
        <li><b>Retail Stores:</b> Protect products from sun damage while keeping storefronts inviting.</li>
        <li><b>Hospitals and Clinics:</b> Offer patient comfort through temperature and privacy control.</li>
        <li><b>Schools and Universities:</b> Improve learning spaces by reducing glare and heat buildup.</li>
      </ul>
    </section>
    <div className="dyed-reflective-img-center">
      <img src="https://i.postimg.cc/k4zCy0TN/dyed-reflective-derma.png" alt="Dyed Reflective Derma Example" className="dyed-reflective-content-img" />
    </div>

    <section className="dyed-reflective-tech">
      <h2>Technology You Can Trust (Without the Complexity)</h2>
      <p>Thanks to a precision-controlled microstructure, these films deliver high visible clarity from the inside while exhibiting a strong, mirror-like reflectivity from the outside. This optical arrangement enhances both transparency and privacy, giving you the best of both worlds — without compromising aesthetics or performance.</p>
    </section>

    <section className="dyed-reflective-sleek">
      <h2>Sleek. Smart. Secure.</h2>
      <p>Reflective films offer more than just solar control — they bring comfort, protection, and style to any building they're applied to.</p>
    </section>

    <section className="dyed-reflective-models">
      <h2>Reflective Films</h2>
      <div className="dyed-reflective-table-wrapper">
        <table className="dyed-reflective-table models">
          <thead>
            <tr>
              <th>Model</th>
              <th>VLT</th>
              <th>IRR</th>
              <th>UVR</th>
              <th>O.D</th>
              <th>TSER</th>
            </tr>
          </thead>
          <tbody>
            {models.map(model => (
              <tr key={model.name}>
                <td>{model.name}</td>
                <td>{model.VLT}</td>
                <td>{model.IRR}</td>
                <td>{model.UVR}</td>
                <td>{model.OD}</td>
                <td>{model.TSER}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  </main>
);

export default DyedReflectivePage; 